module.exports = __webpack_public_path__ + "img/safety-homepage.ab3f6e11.png";